export const PerPage = [5, 10, 20, 30, 50, 100];

export const DefaultPerPageValue = 10;

export const Action = {
  VIEW: "View",
  CREATE: "Create",
  EDIT: "Edit",
  UPDATE: "Update",
  DELETE: "Delete",
  SUBMIT: "Submit",
  APPROVE: "Approve",
  APPROVE_REJECT_SHOW: 'approve_reject_show',
};

export const Review = {
  YES: 'Yes',
  NO: 'No',
  PARTIALLY: 'Partially'
}

export const AcceptFileType = ['.doc', '.docx', '.pdf', '.txt', '.xls', '.xlsx', '.csv', '.ppt', '.pptx', '.jpg', '.jpeg', '.png', '.zip']
export const AcceptProfileFileType = ['jpg', 'jpeg', 'png', 'gif', 'bmp']
export const AcceptProjectLogoType = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.JPEG']

export const RiskImpactAndProbability = {
  VERY_HIGH: 'Very High',
  HIGH: 'High',
  MEDIUM: 'Medium',
  VERY_LOW: 'Very Low',
  LOW: 'Low'
}

export const ProjectTag = {
  ACTIVE: 'Activate',
  INACTIVE: 'Deactivate',
  STOP: 'Stopped'
}

export const UserStatus = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  WAITINGFORACTIVATION: 'Waiting for Activation'
}

export const Role = {
  ROOT_ADMIN: 'Root Admin',
  EPMO_MANAGER: 'Epmo Manager',
  EPMO_OFFICER: 'Epmo Officer',
  VICE_PRESIDENT: 'Vice President',
  PRESIDENT: 'President',
  PORTFOLIO_MANAGER: 'Manager',
  PROGRAM_MANAGER: 'Program Manager',
  PROJECT_SPONSOR: 'Project Sponsor',
  PROJECT_OWNER: 'Project Owner',
  PROJECT_MANAGER: 'Project Manager',
  MEMBER: 'Member',
  MENTOR: 'Mentor'
}

export const NotificationEvent = {
  PROJECT_APPROVAL_REQUESTED: 'project-approval-requested',
  PROJECT_APPROVAL_APPROVED: 'project-approval-approved',
  PROJECT_APPROVAL_REJECTED: 'project-approval-rejected',
  PROJECT_SUBMISSION_REJECTED: 'project-submission-rejected',
  MILESTONE_SUBMISSION_APPROVED: 'milstone-submission-approved',
  MILESTONE_SUBMISSION_REQUESTED: 'milstone-submission-requested',
  MILESTONE_SUBMISSION_REJECTED: 'milstone-submission-rejected',
  DELIVERABLE_SUBMISSION_REQUESTED: 'deliverable-submission-requested',
  DELIVERABLE_SUBMISSION_APPROVED: 'deliverable-submission-approved',
  DELIVERABLE_SUBMISSION_REJECTED: 'deliverable-submission-rejected',
  PROJECT_SUBMISSION_REQUESTED: 'project-submission-requested',
  PROJECT_SUBMISSION_APPROVED: 'project-submission-approved',
  CHANGE_REQUEST_APPROVAL_REQUESTED: 'change-request-approval-requested',
  CHANGE_REQUEST_APPROVAL_APPROVED: 'change-request-approval-approved',
  CHANGE_REQUEST_APPROVAL_REJECTED: 'change-request-approval-rejected',
  TASK_ASSIGNED: 'task-assigned',
  PROJECT_ANNOUNCEMENT: 'project-announcement',
  WORKSHOP: 'workshop-create-update'
}
